import React from "react";
import {PricingBreakdownList} from "../Components/pricingBreakdownList.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";

export function PricingBreakdown({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} cancelButtonType="icon" backStep={previousStep || 'selectedCarDetails'} showBackButton={true} enableEditModeOnBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <PricingBreakdownList props={{setStep}} hideKeys={['tax', 'grand_total']} stripExclTax={true}/>
            </div>
        </>
    );
}
export default PricingBreakdown;
